<template lang="html">
	<header class="navbar navbar-header navbar-header-fixed">
		<a href="" id="mainMenuOpen" class="burger-menu"><feather type="menu"></feather></a>
		<div class="navbar-brand"><router-link class="df-logo" :to="{name:'main'}">Accu<span>LIMS</span></router-link></div><!-- navbar-brand -->
		<!-- <div><sbig/></div> -->
		<div id="navbarMenu" class="navbar-menu-wrapper">
			<div class="navbar-menu-header">
				<a href="" class="df-logo">Accu<span>LIMS</span></a>
				<a id="mainMenuClose" href=""><feather type="x"></feather></a>
			</div><!-- navbar-menu-header -->
			<div class="sidebar-header">
				<h5>Search</h5>
				<a href="" id="sidebarMenuOpen"><feather type="search"></feather></a>
			</div>
			<ul class="nav navbar-menu mw-100">
				<li class="nav-label pd-l-15 pd-lg-l-25 d-lg-none">Main Navigation</li>
				<li @click="menuClick()" class="nav-item with-sub" v-for="menuHeader in menuHeaders">
					<a href="#" class="nav-link">{{menuHeader.mains}}</a>
					<ul class="navbar-menu-sub">
						<li class="nav-sub-item" v-for="submenu in menuHeader.subs" :key="submenu.id">
							<a class="nav-sub-link" v-if="submenu.menuName !== 'Sample List'" @click="goMenu(submenu.menuRoute, submenu.id, submenu)">{{submenu.menuName}}</a>
						</li>
					</ul>
				</li>
			</ul>
		</div><!-- navbar-menu-wrapper -->
		<div class="navbar-right">
			<div class="dropdown dropdown-message"><a href="" class="dropdown-link new-indicator" data-toggle="dropdown"><feather type="message-square"></feather><span v-if="this.totalRead != 0">{{totalRead}}</span></a>
				<div class="dropdown-menu dropdown-menu-right">
					<div class="dropdown-header" v-for="(form, i) in pushData">
                        <template>
                            <b-taglist attached>
                                <b-tag type="is-dark">{{form.type}}</b-tag>
                                <b-tag v-if="form.type=='Message'"><a id="chatModal" href="#modal99" @click="chatModal(form.refId)" data-toggle='modal'>{{form.receptionNo}}</a></b-tag>
                                <b-tag v-else-if="form.type=='Approval'"><a href="#" @click="approvalExp(form)">{{form.experimentNo}}</a></b-tag>
                                <b-tag type="is-info">{{form.read}}</b-tag>
                            </b-taglist>
                        </template>
                    </div>
					<div class="dropdown-footer"><a @click="viewAllMessage()">Read All</a></div>
				</div><!-- dropdown-menu -->
			</div>
			<div class="dropdown dropdown-profile">
				<a href="" class="dropdown-link a-black" data-toggle="dropdown" data-display="static">
					<div class="avatar avatar-sm"><feather type="user"></feather></div>
				</a><!-- dropdown-link -->
			<div class="dropdown-menu dropdown-menu-right">
				<h6 class="tx-semibold mg-b-5">{{userHeaders.companyName}}</h6>
				<p class="mg-b-25 tx-12 tx-color-03">{{userHeaders.userName}}</p>
				<a @click="isComponentModalActive = true" class="dropdown-item"><feather type="edit-3"></feather> Edit Password</a>
				<div class="dropdown-divider"></div>
					<a href="" class="dropdown-item" v-on:click="logout"><feather type="log-out"></feather>Sign Out</a>
				</div><!-- dropdown-menu -->
			</div><!-- dropdown-link -->
		</div><!-- navbar-right -->

        <div class="modal" id="modal99" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel99" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered chat-width" role="document">
                <div class="modal-content tx-14 chat-height">
                    <div class="modal-header">
                        <h6 class="modal-title" id="exampleModalLabel5">Chat</h6>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <HeaderChat></HeaderChat>
                    </div>
                </div>
            </div>
        </div><!-- chat modal -->

		<b-modal :active.sync="isComponentModalActive"
                 has-modal-card
                 trap-focus
                 aria-role="dialog"
                 aria-modal>
            <div class="modal-card" style="width: 250px">
                <header class="modal-card-head">
                    <p class="modal-card-title">Edit Password</p>
                </header>
                <section class="modal-card-body">
                    <b-field label="Password">
                        <b-input
                            type="password"
							id="password"
							ref="password"
                            v-model="password"
                            password-reveal
                            placeholder="Your password"
                            required>
                        </b-input>
                    </b-field>

                    <b-field label="Confirm Password">
                        <b-input
                            type="password"
							id="cpassword"
							ref="cpassword"
                            v-model="cpassword"
                            password-reveal
                            placeholder="Your password"
                            required>
                        </b-input>
                    </b-field>

                </section>
                <footer class="modal-card-foot">
                    <button class="button" type="button" @click="initialPwd()">Close</button>
                    <button class="button is-primary" @click="editPass">Edit</button>
                </footer>
            </div>
        </b-modal>
   	</header><!-- navbar -->
</template>
<script>
    import { bus } from "../../main";
    import common from "@/views/Common/common.js";
	import HeaderChat from "@/views/Common/HeaderChat";
	import { secretKey } from '@/config/config'
	import crypto from 'crypto-js'
	import sbig from '@/images/sbig.svg';
	// document.body.style.zoom = '80%';

	export default {
        name: "headers",
        props: ['properties'],
		data() {
			return {
				menuHeaders: [],
                userHeaders: [],
                totalRead: 0,
                receptionNo: '',
                pushData:[],
                notiChat: false,
                chatData: {},
				chat:'',
				isComponentModalActive: false,
				password:'',
				cpassword:'',
			};
		},
	created() {
		this.$axios.defaults.headers.common["x-access-token"] = this.$store.getters.getAccessToken;
        this.$axios.defaults.headers.common["x-refresh-token"] = this.$store.getters.getRefreshToken;
        this.classifyMenu();
        this.getRealTimeNotify();
		//window.addEventListener('beforeunload', this.window_closed);
		//window.addEventListener('unload', this.window_closed);
    },
    mounted() {
        if(!common.isNull(this.$socket._callbacks.$notification)) {
            this.$socket._callbacks.$notification = this.$socket._callbacks.$notification[this.$socket._callbacks.$notification.length]
        }
        this.$socket.on('notification', (data, total) => {
            this.totalRead = total;
            this.pushData = data;
        });

    },
	methods: {
		window_closed: function window_closed(event) {
			event.returnValue = "closed???";
			//this.logout();
        },
       
		async classifyMenu() {
			await this.$axios.get(this.$apiHost + "/users/mainmenu")
			.then(res => {
				for (let i in res.data) {
                    this.menuHeaders.push(res.data[i]);
                }
			})
			.catch(err => {
				this.logout();
				console.log(err);
			});
			bus.$emit("menu_data", this.menuHeaders);
			this.classifyUser();

        },
        chatModal(id) {
            bus.$emit("receptid", id);
        },
		async classifyUser() {
			const token = this.$store.getters.getAccessToken;
			var base64Url = token.split(".")[1];
			var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
			var jsonPayload = decodeURIComponent(atob(base64).split("").map(function(c) {return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);}).join(""));
            let userData = JSON.parse(jsonPayload);
            this.userHeaders = userData;
			bus.$emit("companyid", userData.companyId);
			bus.$emit("userinfo", userData);
        },
		async menuClick() {
			if (event.target.className == "nav-link") {
				$(event.target).parent().toggleClass("show");
				$(event.target).parent().siblings().removeClass("show");
			}
		},
		async goMenu(name, mid, menu) {
			// this.$router.push({name: name, params:{mid: mid,type: 'list'}});
			// if (name == 'results') { // 분석 결과 화면은 메뉴 네임으로 task 체크 
				this.$router.push({name: name, params: { mid: mid, type: "list", task: menu.menuName}});

			// } else {
			// 	this.$router.push({ name: name, params: { mid: mid, type: "list"} });
			// }
		},
		logout() {
			sessionStorage.removeItem("type");
			sessionStorage.removeItem("mid");
			sessionStorage.removeItem("uid");
			sessionStorage.removeItem("sid");
			sessionStorage.removeItem("msid");
			sessionStorage.removeItem("task");
			this.$store.dispatch("SIGNOUT").then(() => this.$router.go("/"));
        },
        getRealTimeNotify() {
            const token = this.$store.getters.getAccessToken;
			var base64Url = token.split(".")[1];
			var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
			var jsonPayload = decodeURIComponent(atob(base64).split("").map(function(c) {return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);}).join(""));
            let userData = JSON.parse(jsonPayload);
            if(common.isNull(this.$socket._callbacks.$notification)) {
                this.$socket.emit('notification', {userData: userData});
            }
        },
        async approvalExp(form) {
            let params = [];
            params = form;
            this.$axios.patch(this.$apiHost + '/notifies', {
                form
            })
            .then((res) => {
                this.$router.push({
                    name: "experiments_detail",
                    params: { mid: form.menuId, uid: form.refId, type: "detail" }
                });
            });
        },
        async viewAllMessage() {
			this.$axios.delete(this.$apiHost+'/notifies/');
			this.totalRead = 0;
            this.pushData = [];
		},
		async editPass() {
			let check = /^(?=.*[a-zA-Z])(?=.*[0-9]).{4,12}$/.test(this.password); 

			if (this.password) {
				if (check) {
					if (this.cpassword) {
						if (this.password == this.cpassword) {
							let pwd = this.password;
							pwd = crypto.AES.encrypt(pwd, secretKey).toString();
							let params = [];
							params = {
								pwd: pwd
							}
							const result = await this.$axios.post(this.$apiHost + "/users/editpwd",params);
							if (result.data.flag) {
								this.$buefy.dialog.alert({
									message: 'Complete!',
									size: 'is-medium',
								})
								this.initialPwd();
							} else {
								this.$buefy.dialog.alert({
									message: 'You cannot reuse an old password.',
									size: 'is-medium',
									type: 'is-danger'
								})
								this.cpassword = '';
								this.$refs.password.focus();
								return false;
							}
						} else {
							this.$buefy.dialog.alert({
								message: 'Please check comfirm password.',
								size: 'is-medium',
								type: 'is-danger'
							})
							this.$refs.cpassword.focus();
							return false;
						}
					} else {
						this.$buefy.dialog.alert({
							message: 'Please enter comfirm password.',
							size: 'is-medium',
							type: 'is-danger'
						})
						this.$refs.cpassword.focus();
						return false;
					}
				} else {
					this.$buefy.dialog.alert({
						message: 'Passwords must contain 4~12 characters; English Letter and Number only.',
						size: 'is-medium',
						type: 'is-danger'
					})
					this.cpassword = '';
					this.$refs.password.focus();
					return false;
				}
			} else {
				this.$buefy.dialog.alert({
					message: 'Please enter Password.',
					size: 'is-medium',
					type: 'is-danger'
				})
				return false;
			}
		},
		initialPwd() {
			this.password = '';
			this.cpassword = '';
			this.isComponentModalActive = false;
			return false;
		}
	},
		components: {
            // NChat,
			HeaderChat,
			sbig,
        },
		computed: {},
		watch: {},
	};
</script>


// WEBPACK FOOTER //
// src/views/Common/Header.vue